<template>
  <div class="button-component px-3" :class="{ active }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ButtonComponent',
  props: {
    active: Boolean,
  },
}
</script>

<style lang="postcss" scoped>
.button-component {
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: var(--contrast);
  user-select: none;
  transition: background-color 0.2s;
  &:hover {
    background-color: var(--contrast-accentuate);
  }

  &.active {
    color: var(--primary);
  }
}
</style>
